import ImageCardList from "../luiss_components/image_card_list/image_card_list";
import NavigationSliderII from "../luiss_components/navigation_slider_ii/navigation_slider_ii";
import ImgParagraphCta from "../luiss_components/img_paragraph_cta/img_paragraph_cta";
import VideoContainer from "../luiss_components/video_container/video_container";
import C0CustomBlock from "../luiss_components/c0_custom_block/c0_custom_block";
import SliderCTAUI from "../luiss_components/Slider_CTA_UI/Slider_CTA_UI";
import UniversitaPartner from "../luiss_components/universita_partner/universita_partner";
import SummerschoolEstero from "../luiss_components/summerschool_estero/summerschool_estero";
import C5BloccoNews from "../luiss_components/c5_blocco_news/c5_blocco_news";
import TwoColumnsText from "../luiss_components/c6_two_columns_text/two_columns_text";
import TimelineSlider from "../luiss_components/c8_timeline/timeline_slider";
import ImageTextButton from "../luiss_components/c_9_image_text_button/c9_image_text_button";
import ModuloNumeriUI from "../luiss_components/modulo_numeri_ui/modulo_numeri_ui";
import Rankings from "../luiss_components/c_11_rankings/rankings";
import TextCenterEnLabs from "../luiss_components/text_center_enlabs/text_center_enlabs";
import TableComponent from "../luiss_components/c15_table/table_component";
import ConsiglioDiAmministrazione from "../luiss_components/c16_consiglio_di_amministrazione/c16_consiglio_di_amministrazione";
import AltriComponenti from "../luiss_components/c17_altri_componenti/c17_altri_componenti";
import BoxTextSliderImgGroup from "../luiss_components/c20_box_text_slide_image_group/box_text_slide_image_group";
import BandiAperti from "../luiss_components/c22_bandi_aperti/c22_bandi_aperti";
import FilterContracts from "../luiss_components/c22_filter_contracts/filter_contracts";
import CosaImparerai from "../luiss_components/c27_cosa_imparerai/c27_cosa_imparerai";
import AccordionUI from "../luiss_components/c28_accordion_ui/c28_accordion_ui";
import IlTuoFuturo from "../luiss_components/c29_il_tuo_futuro/c29_il_tuo_futuro";
import VideoCarouselUI from "../luiss_components/c30_video_carousel/c30_video_carousel";
import AgevolazioniEconomiche from "../luiss_components/c31_agevolazioni_economiche/c31_agevolazioni_economiche";
import C32TextInColumn from "../luiss_components/c32_text_in_column/c32_text_in_column";
import NavigationSliderSmallCard from "../luiss_components/c33_navigation_slider_small_card/c33_navigation_slider_small_card";
import QuoteSlider from "../luiss_components/c34_quote_slider/quote_slider";
import VerticalSlideCards from "../luiss_components/c35_vertical_small_cards/vertical_slide_cards";
import C36DiscoverCards from "../luiss_components/c36_discover_cards/c36_discover_cards";
import AccordionFAQ from "../luiss_components/c38_faq_accordion/c38_faq_accordion";
import ImageCarouselUI from "../luiss_components/c39_image_carousel_ui/c39_image_carousel_ui";
import PhotoCarousel from "../luiss_components/c40_photo_carousel/c40_photo_carousel";
import AvvisiGrid from "../luiss_components/c41_avvisi/c41_avvisi";
import C42Formstack from "../luiss_components/c42_formstack/c42_formstack";
import C47Sign from "../luiss_components/c47_sign/c47_sign";
import SlideGroupCard from "../luiss_components/c48_slide_group_card/slide_group_card";
import C49Map from "../luiss_components/c49_map/c49_map";
import Concorsi from "../luiss_components/c50_concorsi/c50_concorsi";
import TutteLeStorie from "../luiss_components/c53_tutte_le_storie/c53_tutte_le_storie";
import TutteLeNotizie from "../luiss_components/c52_tutte_le_notizie/c52_tutte_le_notizie";
import C54AImage from "../luiss_components/c54a_image/c54a_image";
import C54BQuote from "../luiss_components/c54b_quote/c54b_quote";
import C55RightImage from "../luiss_components/c55_right_image/c55_right_image";
import Commission from "../luiss_components/c56_commission/commission";
import Conventions from "../luiss_components/c57_conventions/conventions";
import TwoColVideoPlayer from "../luiss_components/c58_two_col_video_player/c58_two_col_video_player";
import CallTiming from "../luiss_components/c_59_call_timing/call_timing";
import PersonSimpleEmail from "../luiss_components/c60_person_simple_email/c60_person_simple_email";
import C61GreyTitleContent from "../luiss_components/c61_grey_title_content/c61_grey_title_content";
import BlockquoteRecommendation from "../luiss_components/c64_blockquote/c64_blockquote";
import C65VideoSliderCarousel from "../luiss_components/c65_video_slide/video_slider";
import C66MultiLayoutText from "../luiss_components/c66_multi_layout_text/c66_multi_layout_text";
import SocialSharing from "../luiss_components/c67_social_sharing/social_sharing";
import CourseDetail from "../luiss_components/c25b_course_detail/course_detail";
import C68AvvisiDipartimenti from "../luiss_components/c68_avvisi_dipartimenti/c68_avvisi_dipartimenti";
import CalendarioAcademico from "../luiss_components/c70_Calendario_Accademico/c70_Calendario_Accademico";
import RedirectTo from "../common_components/redirect_to/redirect-to";
import C12Button from "../left_items/c12_button/c12_button";
import C14FloatingBarLeftItem from "../left_items/c14_floating_bar/c14_floating_bar";
import C21TSiblingsNav from "../left_items/c21t_siblings_nav/c21t_siblings_nav";
import C26TCourseLeftItem from "../left_items/c26t_corso_left_item/c26t_corso_left_item";
import C37THtmlPopup from "../left_items/c37t_html_popup/c37t_html_popup";
import C69Faculty from "../luiss_components/c69_faculty/c69_faculty";
import C70Scholars from "../luiss_components/c70_scholars/c70_scholars";
import C75ProfessorshipSearch from "../luiss_components/c75_professorship_search/c75_professorship_search";
import C77Professorship from "../luiss_components/c77_professorship/c77_professorship";
import C76TwoColumnsTable from "../luiss_components/c76_two_columns_table/c76_two_columns_table";
import C78LeftVideo from "../luiss_components/c78_left_video/c78_left_video";
import C79Professor from "../left_items/c79_professor/c79_professor";
import C75ConvenzioniA from "../luiss_components/c75_convenzioni_a/c75_convenzioni_a";
import C76ConvenzioniB from "../luiss_components/c76_convenzioni_b/c76_convenzioni_b";
import C79Highlighter from "../luiss_components/c79_highlighter/c79_highlighter";
import c80ViewNewsFiltered from "../luiss_components/c80_tutte_le_notizie_filtered/c80tutte_le_notizie_filtered";
import C81CorsiEMaster from "../left_items/c81_corsi_e_master/c81_corsi_e_master";
import C82CorsiEMasterCards from "../luiss_components/c82_corsi_e_master_cards/c82_corsi_e_master_cards";
import C83BannerWithImage from "../left_items/c83_banner_with_image/c83_banner_with_image";
import C72BoxesWithLinks from "../luiss_components/c72_boxes_with_links/c72_boxes_with_links";
import C73CoursesPrefiltered from "../luiss_components/c73_courses_prefiltered/c73_courses_prefiltered";
import C84CourseDirector from "../luiss_components/c84_course_director/c84_course_director";
import C85SliderAlumniStudents from "../luiss_components/c85_slider_alumni_students/c85_slider_alumni_students";
import c86AccordionsWithTables from "../luiss_components/c86_accordions_with_tables/c86_accordions_with_tables";
import c87SliderImagesWithHover from "../luiss_components/c87_slider_images_with_hover/c87_slider_images_with_hover";
import C88BoxTitleImageCTA from "../left_items/c88_box_title_image_cta/c88_box_title_image_cta"
import c89UniquenessSlider from "../luiss_components/c89_luiss_slider/c89_luiss_slider";
import C90ContactForm from "../left_items/c90_contact_form/c90_contact_form";
import c91ProfileCardWithModal from "../luiss_components/c91_profile_card_with_modal/c91_profile_card_with_modal";
import C92ProfileBoxes from "../left_items/c92_profile_boxes_with_links/c92_profile_boxes_with_links";
import C93HomeContact from "../luiss_components/c93_home_contact/c93_home_contact";
import C95HomeSlider from "../luiss_components/c95_home_slider/c95_home_slider"
import C96HomeCollection from "../luiss_components/c96_home_collection/c96_home_collection"
import C99CardsImage from "../luiss_components/c99_cards_image/c99_cards_image";
import C94HomeHero from "../luiss_components/c94_home_hero/c94_home_hero";
import C97FactCards from "../luiss_components/c97_fact_cards/c97_fact_cards";
import C98Programmes from "../luiss_components/c98_programmes/c98_programmes";
import C100ProfileCard from "../luiss_components/c100_profile_card/c100_profile_card";

export const COMPONENTS: Map<string, any> = new Map<string, any>([
    ["cardwithimagegroup", ImageCardList], // c A
    ["card_group_two_columns", NavigationSliderII], // c B
    ["box_text_with_image", ImgParagraphCta], // c C
    ["video_container", VideoContainer],
    ["simple_text_with_title", C0CustomBlock], // c 0
    ["image_with_text_group", SliderCTAUI], // c 2
    ["partner_group", UniversitaPartner], // c 3
    ["box_image_background", SummerschoolEstero], // c 4
    ["blocco_news", C5BloccoNews], // c 5
    ["column_group", TwoColumnsText], // c 7
    ["person_group", TimelineSlider], // c 8
    ["box_text_with_side_image", ImageTextButton], // c 9
    ["circle_group", ModuloNumeriUI], // c 10
    ["card_small_with_image_group", Rankings], // c 11
    ["box_text", TextCenterEnLabs], // c 13
    ["table", TableComponent], // c 15
    ["person_with_text_image_group", ConsiglioDiAmministrazione], // c 16
    ["person_list_group", AltriComponenti], // c 17
    ["box_text_with_side_image_group", BoxTextSliderImgGroup], // c 20
    ["blocco_bandi", BandiAperti], // c 22 |
    ["mod_filter-contracts", FilterContracts], // c 22 |
    ["text_simple_in_column", CosaImparerai], // c 27
    ["table_semester", AccordionUI], // c 28
    ["card_with_text_image", IlTuoFuturo], // c 29
    ["slider_of_cards_with_video", VideoCarouselUI], // c 30
    ["card_with_text_group", AgevolazioniEconomiche], // c 31
    ["text_in_column", C32TextInColumn], // c 32
    ["card_small_group", NavigationSliderSmallCard], // c 33
    ["quote_group", QuoteSlider], // c 34
    ["vertical_scrolling_cards", VerticalSlideCards], // c 35
    ["cardgroup", C36DiscoverCards], // c 36
    ["faq", AccordionFAQ], // c 38
    ["gallery", ImageCarouselUI], // c 39
    ["slides_group", PhotoCarousel], // c 40
    ["viewavvisi", AvvisiGrid], // c 41
    ["formstack", C42Formstack], // c 42
    ["sign", C47Sign], // c 47
    ["card_with_address_group", SlideGroupCard], // c 48
    ["card_with_address_image_group", C49Map], // c 49
    ["c50_concorsi", Concorsi],
    ["viewstories", TutteLeStorie], // c 53
    ["vistanews", TutteLeNotizie], // c 52
    ["image", C54AImage], // c 54a
    ["elements_in_column", C54BQuote], // c 54b
    ["text_and_image", C55RightImage], // c 55
    ["person_simple_group", Commission], // c 56
    ["box_text_address_group", Conventions], // c 57
    ["video", TwoColVideoPlayer], // c 58
    ["table_simple", CallTiming], // c 59
    ["person_simple_with_email_group", PersonSimpleEmail], // c 60
    ["text_in_column_2", C61GreyTitleContent], // c 61
    ["quote", BlockquoteRecommendation], // c 64
    ["gallery_video", C65VideoSliderCarousel], // c 65
    ["multi_layout_text", C66MultiLayoutText], // c 66
    ["social_sharing", SocialSharing], // c 67
    ["course_detail", CourseDetail], // c 25b
    ["vieweventi", AvvisiGrid],
    ["blocco_avvisi", C5BloccoNews],
    ["blocco_avvisi_esterni", C68AvvisiDipartimenti], // c 68
    ["view_calendario_accademico", CalendarioAcademico],
    ["faculty", C69Faculty], // c 69
    ["scholars", C70Scholars], // c 70
    ["redirect_to", RedirectTo],
    ["search_cattedreonline", C75ProfessorshipSearch], // c 75
    ["two_columns_table", C76TwoColumnsTable], // c 76
    ["professorship", C77Professorship], // c 77
    ["view_convenzioni", C75ConvenzioniA], //c 75
    ["blocco_convenzioni", C76ConvenzioniB], //c 76
    ["highlight_box", C79Highlighter], // c79
    ["view_news_filtered", c80ViewNewsFiltered], //c80
    ["corsi_master_views", C82CorsiEMasterCards], //c82
    ["__single_column_corsi_master_views", C73CoursesPrefiltered], // c 73
    ["boxes_with_links", C72BoxesWithLinks], // c 72
    ["course_director", C84CourseDirector], //c84
    ["slider_alumni_students", C85SliderAlumniStudents], //c85
    ["accordions_with_tables", c86AccordionsWithTables], //c86
    ["slider_images_with_hover", c87SliderImagesWithHover], //c87
    ["uniqueness_slides", c89UniquenessSlider], //c89
    ["profile_card_with_modal", c91ProfileCardWithModal], //c91
    ["home_contact", C93HomeContact],
    ["home_title_text_with_cards", C95HomeSlider],
    ["home_vieweventi", C95HomeSlider],
    ["home_vistanews", C95HomeSlider],
    ["home_text_image_with_slider", C96HomeCollection],
    ["home_text_image_with_cards", C99CardsImage],
    ["home_hero", C94HomeHero],
    ["home_title_text_with_cards_blue", C97FactCards],
    ["home_colored_cards", C98Programmes],
    ["faculty_profile", C100ProfileCard],
]);

export const LEFT_ITEMS: Map<string, any> = new Map<string, any>([
    ["button_action", C12Button], // c 12
    ["sticky_bar", C14FloatingBarLeftItem], // c 14
    ["menu_block", C21TSiblingsNav], // c 21
    ["course_summary", C26TCourseLeftItem], // c 26
    ["pop_up", C37THtmlPopup], // c 37
    ["left_video", C78LeftVideo], // c 78
    ["professor", C79Professor], // c 79
    ["boxes_with_links_checked", C81CorsiEMaster], //c81
    ["banner_with_image", C83BannerWithImage], //c83
    ["box_title_image_cta", C88BoxTitleImageCTA], //c88
    ["contact_form", C90ContactForm], // c 90
    ["profile_boxes_with_links", C92ProfileBoxes] //c92
]);
